module.exports = __webpack_public_path__ + "static/media/img83_R.dee31e8d.jpg";